import { PropsFilter } from "../../../models/api/props-filter/props-filter";
import { ListSortDirection } from "../../../models/api/sort/list-sort-direction";
import { HiringClientDTO, HiringClientSTO } from "../../../models/recruiting/hiring-clients";
import { BaseApiService } from "../../base/base-api.service";
import { toastifyResponse } from "../../../utils/toastify-response/toastify-response";
import { Sort } from "../../../models/api/sort/sort";

export class HiringClientsApiService extends BaseApiService<HiringClientDTO, HiringClientSTO> {
  constructor() {
    super({
      servicePath: "/HiringClients",
      loadItemsPath: "/GetHiringClients",
      saveItemsPath: "/SaveHiringClients",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const loadHiringClients = async (id: string) => {
  const response = await new HiringClientsApiService().loadItems(
    {
      ids: !id ? [] : [id],
      createdByUsers: [],
      modifiedByUsers: [],
      isDeleted: false,
    } as PropsFilter,
    "",
    [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      },
    ],
    { pageNumber: 0, pageSize: 1000 }
  );

  return response;
};

export const updateCurrentHiringClients = async (user: HiringClientSTO) => {
  const usersApiService = new HiringClientsApiService();
  usersApiService.useSaveItemsPath("/UpdateCurrentUser");
  const response = await usersApiService.saveItems([user]);

  toastifyResponse(response, "all");

  return response;
};
